import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';

export const getCountries: any = createAsyncThunk<any>(
	'getCountries',
	async (data) => {
		const response = await httpService.get('common/get-countries', {
			params: data
		});
		return response.data;
	}
);

export const getRegions: any = createAsyncThunk<any>(
	'getRegions',
	async (data) => {
		const response = await httpService.get(`common/region`, {
			params: data
		});
		return response.data;
	}
);

export const getCities: any = createAsyncThunk<any>(
	'getCities',
	async (props: any) => {
		const response = await httpService.get(
			`common/city?regionId=${props.region}&countryId=${props.country}`
		);
		return response.data;
	}
);

export const getCitiesAPI: any = createAsyncThunk<any>(
	'getCitiesAPI',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get('common/city', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const changeUserPassword: any = createAsyncThunk<any>(
	'changeUserPassword',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(
				`common/change-user-password`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const updateProfilePicture: any = createAsyncThunk<any>(
	'updateProfilePicture',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(
				`/common/user-profile-pic`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const getUploadImageSignature: any = createAsyncThunk<any>(
	'getUploadImageSignature',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'common/getUploadSignature',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const deleteProfilePicture: any = createAsyncThunk<any>(
	'deleteProfilePicture',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(
				`/common/deleteImage`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
